import { Action } from "redux";

export const SET_FILTER_SETTING_PARTS_PER_PSM = "SET_FILTER_SETTING_PARTS_PER_PSM";
export const SET_FILTER_SETTING_TACTICAL_PARTS = "SET_FILTER_SETTING_TACTICAL_PARTS";
export const SET_FILTER_SETTING_MISSED_SALES = "SET_FILTER_SETTING_MISSED_SALES";

export interface SetFilterSettingAction extends Action<string> {
    filterSettings: {name: string, value: string}[]
    type: string;
}